import { render, staticRenderFns } from "./barchart.vue?vue&type=template&id=e840cf6c&scoped=true&"
import script from "./barchart.vue?vue&type=script&lang=js&"
export * from "./barchart.vue?vue&type=script&lang=js&"
import style0 from "./barchart.vue?vue&type=style&index=0&id=e840cf6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e840cf6c",
  null
  
)

export default component.exports